module.exports = __webpack_public_path__ + "static/media/screenshot(9).05564b1b.jpg";